import { render, staticRenderFns } from "./DiningTime.vue?vue&type=template&id=6e13536e&scoped=true&"
import script from "./DiningTime.vue?vue&type=script&lang=js&"
export * from "./DiningTime.vue?vue&type=script&lang=js&"
import style0 from "./DiningTime.vue?vue&type=style&index=0&id=6e13536e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e13536e",
  null
  
)

export default component.exports